<template>
  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item clickable"
      @click="editDietCategory"
    >{{ categoryName }}</div>
    <div
      class="Fuell-Table--item clickable"
      @click="editDietCategory"
    >
      <span class="ellipsis">{{ categoryRate | currency('€', 2, {symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ','}) }}</span>
    </div>
    <div class="Fuell-Table--item Fuell-Table--options">
      <dropdown :closeOnClickInside="false">
        <div
          class="clickable"
          role="button"
          @click="editDietCategory"
        >{{$t('ACTION_EDIT')}}</div>
        <div
          class="clickable"
          role="button"
          @click="handleDeleteDietCategory"
        >{{$t('ACTION_REMOVE')}}</div>
      </dropdown>
    </div>
    <confirm-modal
      v-if="showConfirmModal"
      :open.sync="showConfirmModal"
      @accept="deleteDietCategory"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
    ></confirm-modal>
  </div>
</template>

<script>
import Dropdown from '@/components/Commons/Dropdown'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'MileageCategoryTableRosw',
  components: { Dropdown, ConfirmModal },
  props: {
    dietCategory: {
      type: Object
    }
  },
  data () {
    return {
      showConfirmModal: false
    }
  },
  computed: {
    categoryName () {
      return this.dietCategory.name
    },
    categoryRate () {
      return this.dietCategory.rate
    }
  },
  methods: {
    editDietCategory () {
      this.$emit('editDietCategory', this.dietCategory.id)
    },
    handleDeleteDietCategory () {
      this.showConfirmModal = true
    },
    async deleteDietCategory () {
      this.$emit('removeDietCategory', this.dietCategory.id)
      // await this.$store.dispatch('CompanyStore/ExpensesSettingsStore/deleteDietCategory', this.dietCategory.id)
    }
  }
}
</script>
